export const EvaluationPerformance = {
    path: '/evaluation_performances',
    name: 'evaluation_performances',
    component: () => import('@/views/Evaluation/Performance/EvaluationPerformancePage.vue'),
    children: [
        {
            path: '/evaluation_performances/add',
            name: 'evaluation_performances.add',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/evaluation_performances/edit/:id',
            name: 'evaluation_performances.edit',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/evaluation_performances/launch/:id',
            name: 'evaluation_performances.launch',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceLaunchForm.vue'),
        },
        {
            path: '/evaluation_performances/delete/:id',
            name: 'evaluation_performances.delete',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/evaluation_performances/view/:id',
            name: 'evaluation_performances.view',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/evaluation_performances/documents/:id',
            name: 'evaluation_performances.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "EVALUATION_PERFORMANCE"}
        },
        {
            path: '/evaluation_performances/template_applications/:id',
            name: 'evaluation_performances.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "EVALUATION_PERFORMANCE"}
        },
    ]
}

export const EvaluationPerformanceCandidate = {
    path: '/evaluation_performance_candidates',
    name: 'evaluation_performance_candidates',
    component: () => import('@/views/Evaluation/Performance/EvaluationPerformanceCandidatePage.vue'),
    children: [
        {
            path: '/evaluation_performance_candidates/interviews/edit/:id',
            name: 'evaluation_performance_candidates.interviews.edit',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationPerformanceInterviewForm.vue'),
            props: {updateAction: true, getIt: true}
        },
        {
            path: '/evaluation_performance_candidates/interviews/view/:id',
            name: 'evaluation_performance_candidates.interviews.view',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationPerformanceInterviewForm.vue'),
            props: {viewAction: true, getIt: true},
        },
        {
            path: '/evaluation_performance_candidates/tolerate/:id',
            name: 'evaluation_performance_candidates.tolerate',
            component: () => import('@/views/Evaluation/Performance/Form/EvaluationPerformanceTolerateForm.vue'),
        },
    ]
}